var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpdownArrows(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 11,
    viewBox: "0 0 8 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M0.960938 6.25H6.53906C7.03125 6.25 7.28906 6.85938 6.9375 7.21094L4.14844 10C3.91406 10.2344 3.5625 10.2344 3.35156 10L0.5625 7.21094C0.1875 6.85938 0.445312 6.25 0.960938 6.25ZM6.9375 3.78906C7.28906 4.16406 7.03125 4.75 6.53906 4.75H0.960938C0.445312 4.75 0.1875 4.16406 0.5625 3.78906L3.35156 1C3.5625 0.789062 3.91406 0.789062 4.14844 1L6.9375 3.78906Z",
    fill: "#2E375B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdownArrows);
export default __webpack_public_path__ + "static/media/updownArrows.58b38076d5a78917a87de6de77c77ebc.svg";
export { ForwardRef as ReactComponent };